<script setup lang="ts">
import { useFlightAreaStore } from '@/stores/flightArea'

const flightareaStore = useFlightAreaStore()

// リロード時はセッションからエリア情報を復元
flightareaStore.loadFromSession()
</script>

<template>
  <router-view />
</template>

<style scoped></style>
